import httpClient from '../httpClient';


const getBanner =  () => httpClient.get('/MainPage/Banner/Get').then(
  (data) => data
)
  .catch(()=>{
   //
  })
const setBanner =  (params) => httpClient.post('/MainPage/Banner/Post', {
  webImgPath:params.webImgPath,
  mobileImgPath:params.mobileImgPath,
},{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
const putBanner = (params,id) => httpClient.put(`/MainPage/Banner/Put/${id}`, params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })


const  deleteBanner= (id) => httpClient.delete(`/MainPage/Banner/Delete/${id}`,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

export {
  getBanner,
  setBanner,
  putBanner,
  deleteBanner
  // getUser,
  // createUser
}
